import React from 'react';
import Link from 'next/link';
import { ActionSheet } from '@/components/ui/ActionSheet';
import { cn } from '@/lib/utils/cn';
import { SECONDARY_NAV } from './navConfig';

export interface MoreMenuSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MoreMenuSheet({ isOpen, onClose }: MoreMenuSheetProps) {
  return (
    <ActionSheet isOpen={isOpen} onClose={onClose} title="Mais" description="Acesse outras áreas do CRM">
      <div className="grid grid-cols-2 gap-3">
        {SECONDARY_NAV.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.id}
              href={item.href}
              onClick={onClose}
              className={cn(
                'flex flex-col items-start gap-3 rounded-xl',
                'bg-slate-50/80 dark:bg-white/5',
                'border border-slate-200/70 dark:border-white/8',
                'p-4',
                'hover:bg-primary-50/60 dark:hover:bg-primary-900/20',
                'hover:border-primary-200/80 dark:hover:border-primary-900/50',
                'transition-all duration-150 focus-visible-ring'
              )}
            >
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary-50 dark:bg-primary-900/30 border border-primary-100 dark:border-primary-900/50">
                <Icon
                  className="h-[18px] w-[18px] text-primary-600 dark:text-primary-400"
                  aria-hidden="true"
                />
              </span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-100 leading-tight">
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </ActionSheet>
  );
}
